<template>
    <div>
        <card-header title="New Session Group" icon="fa-plus"/>

        <card-body>
            <group-form :group="group" :conf="conference"/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!group.title"
                    ><i class="fas fa-plus mr-2"></i>New Group
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardFooter from "@/TIER/components/CardFooter";

    import {client as http} from "@/http_client";
    import GroupForm from "./GroupForm";
    import moment from "moment/moment";

    export default {
        components: {GroupForm, CardHeader, CardBody, CardFooter},
        props: ['card', 'props'],
        data() {
            return {
                group: {},
                conference: {}
            };
        },
        methods: {
            loadConference: function(force) {
                this.$emit('loading', true);

                http.get('conferences/' + this.props.confId, {force}).then(response => {
                    response.data.start_at = moment(response.data.start_at).toDate();
                    response.data.end_at = moment(response.data.end_at).toDate();

                    this.conference = response.data;

                    this.$emit('loading', false);
                }).catch(err => {

                });
            },
            submit: function() {
                this.$emit('loading', true);
                http.post('conferences/' + this.props.confId + '/groups', {conference_id: this.props.confId, ...this.group}, {force: true}).then(response => {
                    this.$reloadCard('conf-groups');
                    this.$closeCard(this.card);
                }).catch(err => {
                    window.alert('An error occurred while saving the session group.');
                    this.$emit('loading', false);
                });
            }
        },
        created() {
            this.loadConference();
        }
    };
</script>
